import MainLayout from "layouts/MainLayout";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  editOpeningCaseFile,
  fetchOpeningCaseFileById,
} from "services/caseServices";
import { DailyReport, OpeniningCaseFile, Roles } from "types";
import { errorHandlerOnForm, hasRole } from "utils/helper";
// import FeedbackSection from "./FeedbackSection";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { LoadingIcon } from "utils/constant";
import AssignedProsecutorToCourt from "./fragments/AssignProsecutorToCourt";
import CourtInfo from "./fragments/CourtInfo";
import Report from "./fragments/Report";
import DailyReportFeedbackSection from "./fragments/DailyReportFeedbackSection";

const OpeningCaseFilesDetail: React.FC = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const caseData = state?.caseData;
  const navigate = useNavigate();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();

  // const [isAddDailyReportOpen, setIsAddDailyReportOpen] = useState(false);
  // const [isAddDinalVerdictOpen, setIsAddFinalVerdictOpen] = useState(false);
  const [actionIsLoading, setActionIsLoading] = useState(false);

  const [refetch, setRefetch] = useState(false);
  const [page, setPage] = useState("View File");

  const [openingCaseFile, setOpeningCaseFile] = useState<OpeniningCaseFile>();
  const [selectedDailyReport, setSelectedDailyReport] = useState<DailyReport>();

  const isProsecutor = hasRole(loginData?.roles, [Roles.prosecutor]);
  const isRegistrar = hasRole(loginData?.roles, [Roles.registrar]);
  const isCoordinator = hasRole(loginData?.roles, [Roles.coordinator]);

  // const [dailyReports, setDailyReports] = useState<DailyReport[]>([]);
  // const [finalVerdicts, setFinalVerdicts] = useState<FinalVerdict[]>([]);
  // const [finalVerdictStatus, setFinalVerdictStatus] =
  //   useState<string>("daily-report");

  useEffect(() => {
    if (!caseData) return;
    fetchOpeningCaseFileById(caseData?.id)
      .then(setOpeningCaseFile)
      .catch(console.error);
  }, [caseData, refetch]);

  useEffect(() => {
    if (!openingCaseFile) return;
    // fetchDailyReportByDefendantCaseDetail(
    //   openingCaseFile?.defendant_case_detail_info?.id
    // )
    //   .then((data) => {
    //     setDailyReports(
    //       data?.filter(
    //         (d) =>
    //           d?.crime_refernce_number ===
    //           openingCaseFile?.crime_refernce_number
    //       )
    //     );

    //     setFinalVerdictStatus(
    //       data?.some(
    //         (d) =>
    //           d?.crime_refernce_number ===
    //             openingCaseFile?.crime_refernce_number &&
    //           d?.is_final_verdict_given
    //       )
    //         ? "final-verdict-request"
    //         : "daily-report"
    //     );
    //   })
    //   .catch(console.error);

    // fetchFinalVerdictByDefendantCaseDetail(
    //   openingCaseFile?.defendant_case_detail_info?.id
    // )
    //   .then((data) => {
    //     setFinalVerdicts(
    //       data?.filter(
    //         (d) =>
    //           d?.crime_refernce_number ===
    //           openingCaseFile?.crime_refernce_number
    //       )
    //     );
    //   })
    //   .catch(console.error);
  }, [openingCaseFile]);

  return (
    <MainLayout>
      <div className="incidentRegistration ">
        {/* max-w-screen-lg */}
        <div className="flex flex-row justify-between">
          <div className="w-full flex flex-row justify-between items-center">
            <span className="text-2xl font-semibold text-gray-700">
              ⚖ Trial{" "}
              {openingCaseFile?.status === "assigned_to_prosecutor"
                ? "Procedure"
                : "File"}
            </span>
            {openingCaseFile?.status !== "assigned_to_prosecutor" && (
              <div className="flex flex-row mt-4 gap-3">
                <button
                  type="button"
                  className="bg-[#D4D4D4] px-4 py-2 text-black font-[Poppins] font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                  onClick={() => {
                    navigate("/cases/" + caseData?.case, {
                      state: {
                        caseData: caseData?.case,
                      },
                    });
                  }}
                >
                  Defendant Case
                </button>
                {/* {((openingCaseFile?.status === "Pending" && isRegistrar) ||
                  (openingCaseFile?.status === "forwarded_to_coordinator" &&
                    isCoordinator)) && (
                  <input
                    type="button"
                    className="bg-black cursor-pointer px-4 py-2 text-white font-[Poppins] font-[500] text-base rounded-md hover:bg-black"
                    value={
                      openingCaseFile?.status === "Pending"
                        ? "Forward To Coordinator"
                        : openingCaseFile?.status === "forwarded_to_coordinator"
                        ? "Assign Prosecutor"
                        : "Add Court Detail"
                    }
                    onClick={() => {
                      if (
                        openingCaseFile?.status === "forwarded_to_registrar"
                      ) {
                        navigate("/court-detail", {
                          state: { caseData: openingCaseFile },
                        });
                        return;
                      }

                      editOpeningCaseFile({
                        id: openingCaseFile?.id,
                        status:
                          openingCaseFile?.status === "Pending"
                            ? "forwarded_to_coordinator"
                            : openingCaseFile?.status ===
                              "forwarded_to_coordinator"
                            ? "assigned_to_prosecutor"
                            : "Pending",
                      })
                        .then(() => {
                          showTooltip(t("successful"), "success");
                          setRefetch(!refetch);
                        })
                        .catch((error) => {
                          showTooltip(
                            errorHandlerOnForm(error) ||
                              "Error forwarding case:",
                            "error"
                          );
                        });
                    }}
                  />
                )} */}
              </div>
            )}
            {openingCaseFile?.status === "assigned_to_prosecutor" &&
              isProsecutor && (
                <div className="flex flex-row mt-4 gap-3">
                  <button
                    type="button"
                    className="bg-[#D4D4D4] px-4 py-2 text-black font-[Poppins] font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                    onClick={() => {
                      setPage(
                        page === "View File" ? "View Reports" : "View File",
                      );
                    }}
                  >
                    {page === "View File" ? "View Reports" : "View File"}
                  </button>
                  {/* {finalVerdictStatus === "daily-report" &&
                    finalVerdicts?.length === 0 && (
                      <button
                        type="button"
                        className="bg-[#D4D4D4] px-4 py-2 text-black font-[Poppins] font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                        onClick={() => {
                          setIsAddDailyReportOpen(true);
                        }}
                      >
                        Add Daily Report
                      </button>
                    )} */}
                  {/* {finalVerdictStatus === "final-verdict-request" &&
                    finalVerdicts?.length === 0 && (
                      <button
                        type="button"
                        className="bg-black px-4 py-2 text-white font-[Poppins] font-[500] text-base rounded-md hover:bg-black"
                        onClick={() => {
                          setIsAddFinalVerdictOpen(true);
                        }}
                      >
                        Add Final Verdict
                      </button>
                    )} */}
                </div>
              )}
          </div>
          <div className="w-[500]"></div>
        </div>

        <div className="flex flex-row justify-between mb-4 gap-6">
          <div className="w-full flex flex-col gap-2">
            {page === "View File" ? (
              <CourtInfo file={openingCaseFile} />
            ) : (
              <Report
                // dailyReports={dailyReports}
                // finalVerdicts={finalVerdicts}
                setSelectedDailyReport={setSelectedDailyReport}
                selectedDailyReport={selectedDailyReport}
                caseData={caseData}
                fetchData={function (): void {}}
              />
            )}
          </div>
          <div className="w-[500]">
            {isRegistrar && openingCaseFile?.status === "Pending" && (
              <div className="bg-white shadow-md rounded-lg p-6 mt-4  min-w-[500px]">
                <h2 className="mb-3 font-[Poppins] font-semibold text-base border-b border-[#D4D4D4] pb-2">
                  Registrar Action
                </h2>
                <div className="flex flex-col gap-4 ">
                  <button
                    className={`border bg-[#212121] px-[76px] py-2  w-full mt-3
                        text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]`}
                    onClick={() => {
                      setActionIsLoading(true);

                      editOpeningCaseFile({
                        id: openingCaseFile?.id,
                        status: "forwarded_to_coordinator",
                      })
                        .then(() => {
                          showTooltip(t("successful"), "success");
                          setRefetch(!refetch);
                        })
                        .catch((error) => {
                          showTooltip(
                            error?.response?.data?.detail ||
                              errorHandlerOnForm(error),
                            "error",
                          );
                        })
                        .finally(() => setActionIsLoading(false));
                    }}
                  >
                    {actionIsLoading ? (
                      <div className="flex items-center justify-center">
                        {LoadingIcon}
                        Loading...
                      </div>
                    ) : (
                      "Forward to Coordinator"
                    )}
                  </button>
                </div>
              </div>
            )}
            {openingCaseFile?.status === "forwarded_to_coordinator" &&
              isCoordinator && (
                <AssignedProsecutorToCourt
                  file={caseData}
                  caseData={caseData}
                  assignedProsecutor=""
                  setRefetch={setRefetch}
                />
              )}
            {openingCaseFile?.status === "assigned_to_prosecutor" && (
              <div className="">
                <DailyReportFeedbackSection
                  fetchData={() => {}}
                  selectedDailyReport={selectedDailyReport}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* {isAddDailyReportOpen && openingCaseFile && (
        <AddDailyReport
          openingCaseFile={openingCaseFile}
          action="Add"
          onClose={() => {
            setIsAddDailyReportOpen(false);
            setRefetch(!refetch);
          }}
        />
      )}
      {isAddDinalVerdictOpen && openingCaseFile && (
        <AddFinalVerdict
          openingCaseFile={openingCaseFile}
          action="Add"
          onClose={() => {
            setIsAddFinalVerdictOpen(false);
            setRefetch(!refetch);
          }}
        />
      )} */}
    </MainLayout>
  );
};

export default OpeningCaseFilesDetail;
